import {
  Notification as MantineNotification,
  NotificationProps as MantineNotificationProps,
} from '@mantine/core';
import {
  IconAlertCircle,
  IconAlertTriangle,
  IconCircleCheck,
  IconInfoCircle,
} from '@tabler/icons-react';
import { ReactNode } from 'react';

import styles from './Toast.module.css';

export type ToastVariant =
  'general-note' | 'intro' | 'callout' | 'warning' | 'success' | 'error';

export const VARIANT_ICONS: Record<ToastVariant, ReactNode> = {
  'general-note': <IconInfoCircle size={20} stroke={2} />,
  intro: <IconInfoCircle size={20} stroke={2} />,
  callout: <IconInfoCircle size={20} stroke={2} />,
  warning: <IconAlertTriangle size={20} stroke={2} />,
  success: <IconCircleCheck size={20} stroke={2} />,
  error: <IconAlertCircle size={20} stroke={2} />,
};

export const TOAST_CLASS_NAMES = {
  root: styles.root,
  icon: styles.icon,
  body: styles.body,
  title: styles.title,
  description: styles.description,
  closeButton: styles.closeButton,
};

export interface ToastProps extends Omit<
  MantineNotificationProps,
  'variant' | 'color' | 'styles' | 'classNames' | 'style'
> {
  variant?: ToastVariant;
  /** Show icon. When true, displays variant default or custom icon. Default: true */
  withIcon?: boolean;
}

export const Toast = ({
  variant = 'general-note',
  icon,
  withIcon = true,
  withCloseButton = true,
  children,
  ...props
}: ToastProps) => {
  const defaultIcon = VARIANT_ICONS[variant];
  const resolvedIcon = withIcon ? (icon ?? defaultIcon) : undefined;

  return (
    <MantineNotification
      unstyled
      classNames={TOAST_CLASS_NAMES}
      data-variant={variant}
      icon={resolvedIcon}
      withCloseButton={withCloseButton}
      {...props}
    >
      {children}
    </MantineNotification>
  );
};
